<template>
    <span
      class="pointer"
      :style="{
            opacity: (loading)?0.5:1
          }"
      @click="onChange"
    >
      <v-icon
        :color="isOk?'success':'gray'"
        :small="small"
      >mdi-account-check-outline</v-icon>
    </span>
</template>

<script>
export default {
  name: 'IsPresence',
  props: {
    isOk: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: 'mdi-account',
    },
    updateRequest: {
      type: Function,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    onChange() {
      if (!this.loading) {
        this.updateValue(1 - this.isOk);
      }
    },
    updateValue(value) {
      this.$emit('updated', value);
      if (this.updateRequest) {
        this.loading = true;
        setTimeout(() => {
          this.updateRequest(value)
            .catch((error) => {
              this.$emit('updated', 1 - value);
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }, 0);
      }
    },
  },
};
</script>

<style scoped>

</style>
